angular.module('domain.order', ['ngRoute', 'upResources', 'security.authorization']).config([
	'$upModalProvider',
	function ($upModalProvider) {
		$upModalProvider.modal('editOrder', {
			templateUrl: require('App/upsales/domain/order/views/editOrder.html?file'),
			controller: 'EditOrder as EditOrder',
			style: 'form dynamic default',
			constantHeight: '100%',
			hash: true,
			closeOnCurtain: true,
			rememberHeight: true,
			resolve: {
				authUser: function ($routeGuard) {
					return $routeGuard.requireUser();
				},
				meta: function ($modalParams, EditOrderMeta) {
					return EditOrderMeta($modalParams);
				}
			}
		});
	}
]);
